import { v4 as uuid } from "uuid";

export const LAYOUT_WRAPPER_ID = uuid();
